export default __webpack_public_path__ + "static/media/bills_import_description.98cca561.txt";